export function Card({ children, className, ...props }) {
  return (
    <div 
      className={`bg-slate-900 border border-slate-800 rounded-xl p-6 shadow-xl ${className}`} 
      {...props} // <--- This allows onClick to work
    >
      {children}
    </div>
  );
}
